export const changeListener = (attrib:string, callback: (e:Event)=>void): void => {
    const elements = document.querySelectorAll(`[${attrib}]`);
    elements.forEach((element) => {
        element.addEventListener('change', (e) => {
            callback(e);
        }, true);
    })
}
